export const DEFAULT_DOCUMENT_TITLE = 'CIME Avocats';

/** Titre de l'onglet pour une page nommée : « Digital Cookie TEST · CIME Avocats ». */
export function pageDocumentTitle(pageTitle: string | null | undefined): string {
  const name = pageTitle?.trim();
  return name ? `${name} · ${DEFAULT_DOCUMENT_TITLE}` : DEFAULT_DOCUMENT_TITLE;
}

export function formatUnreadDocumentTitle(
  unreadCount: number,
  baseTitle: string = DEFAULT_DOCUMENT_TITLE,
): string {
  if (unreadCount <= 0) return baseTitle;
  const label = unreadCount > 99 ? '99+' : String(unreadCount);
  return `(${label}) ${baseTitle}`;
}
